export default __webpack_public_path__ + "static/media/a038-6.ebd6c700.svg";